var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAuthorityBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#438afe;stroke:#707070;opacity:0;}.b{fill:#00bcd4;}.c{stroke:none;}.d{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-333 -306)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(333 306)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(336 309)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M212.02,186.563a1.582,1.582,0,1,0-1.584-1.582A1.585,1.585,0,0,0,212.02,186.563Zm0-2.109a.527.527,0,1,1-.53.527A.529.529,0,0,1,212.02,184.454Z",
    transform: "translate(-203.038 -176.951)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M.527,10.325h.547v7.147A.527.527,0,0,0,1.6,18H16.4a.527.527,0,0,0,.527-.527V10.325h.547A.527.527,0,0,0,18,9.8V8.04a.527.527,0,0,0-.342-.494L9.527,4.5V3.164h2.544a.527.527,0,0,0,.527-.527V.527A.527.527,0,0,0,12.072,0H9a.527.527,0,0,0-.527.527V4.5L.342,7.546A.527.527,0,0,0,0,8.04V9.8a.527.527,0,0,0,.527.527Zm4.757,6.62H4.225V12.962a.528.528,0,0,1,.527-.527h0a.528.528,0,0,1,.527.527Zm3.168,0v-4.7a.528.528,0,0,1,.527-.527h0a.528.528,0,0,1,.527.527v4.7Zm5.322,0H12.716V12.962a.528.528,0,0,1,.527-.527h0a.528.528,0,0,1,.527.527ZM9.527,1.055h2.017V2.109H9.527ZM1.055,8.406,9,5.429l7.945,2.977v.865H11.8a.527.527,0,1,0,0,1.055h4.074v6.62H14.829V12.962a1.584,1.584,0,0,0-1.582-1.582h0a1.584,1.584,0,0,0-1.582,1.582v3.983H10.567v-4.7a1.584,1.584,0,0,0-1.582-1.582h0A1.584,1.584,0,0,0,7.4,12.248v4.7H6.339V12.962A1.584,1.584,0,0,0,4.757,11.38h0a1.584,1.584,0,0,0-1.582,1.582v3.983H2.129v-6.62H6.168a.527.527,0,0,0,0-1.055H1.055Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthorityBlue);
export default __webpack_public_path__ + "static/media/authorityBlue.ad39333767b8ebf2aab48e3b74abde0f.svg";
export { ForwardRef as ReactComponent };